import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateOptionConfirmDialog } from 'store/dialog/reducer';

const useOptionConfirmDialog = () => {
    const result = useSelector((state) => state.dialog.optionConfirmDialog.result);
    const involveFlag = useSelector((state) => state.dialog.optionConfirmDialog.involveFlag);
    const dispatch = useDispatch();
    const resolver = useRef();
    const isShow = useSelector((state) => state.dialog.optionConfirmDialog.isShow);

    useEffect(() => {
        if (result === true || result === false) {
            resolver.current && resolver.current({ result, involveFlag });
            if (isShow) {
                dispatch(
                    updateOptionConfirmDialog({
                        isShow: false,
                    }),
                );
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [result]);

    const handleShow = () => {
        setTimeout(() => {
            dispatch(
                updateOptionConfirmDialog({
                    isShow: true,
                    result: undefined,
                }),
            );
        }, 50);

        return new Promise(function (resolve) {
            resolver.current = resolve;
        });
    };

    return handleShow;
};

export default useOptionConfirmDialog;
